import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ProjectListContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{},
            projects:[]
        }
        

    }
 
    componentDidMount()
    {
        var data = { id : this.props.slug} 
            axios.post(api_base_url+"category_projects", data).then(response=>{
                this.setState({projects:response.data}); 
                this.setState({loading:0});
            }); 
    }
    componentDidUpdate(prevProps)
    {
        var data = { id : this.props.slug}
        if (this.props.slug !== prevProps.slug)
        {
            axios.post(api_base_url+"category_projects", data).then(response=>{
                this.setState({projects:response.data}); 
                this.setState({loading:0});
            });
        }
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
  
  <div class="gallery-single default-padding">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">

                        <div class="col-md-12">
                <div class="row">
                    <div class="gallery-details">
                        <h2>PROJECTS LIST</h2><br/>
						<h4>{ this.state.projects.length > 0 ? this.state.projects[0].type : "No projects"}</h4>
                                            
                        <table width="100%" border="1px;" className={ this.state.projects.length > 0 ? "" : "dnone"}>
                        <tbody>
                            <tr>
                                <td width="20%"><h5><strong>PROJECT NAME </strong>  </h5> </td>
                            <td width="20%"><h5><strong>CLIENT</strong></h5> </td>
                                <td width="20%"><h5><strong>CONSULTANT</strong></h5></td>
                                <td width="20%"><h5><strong>MAINCONTRACTOR</strong></h5></td>
                                <td width="20%"><h5><strong>MEP CONTRACTOR</strong></h5></td>
                            </tr>
                        
                         
                            {this.state.projects.map((item, index) => (
                            <tr>
                            <td>{item.title}</td>
                            <td>{item.client}</td>
                            <td>{item.consultant}</td>
                            <td>{item.main_contractor}</td>
                            <td>{item.mep_contractor}</td>
                            </tr>
                            ))}
                                
                        </tbody>
                        </table>                        
                    </div>
                </div>
            </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
        </div>
       

    );
 
    }
}

export default ProjectListContent;